import React from 'react';
import { Badge, BadgeProps } from '@companycam/slab-web';

type BetaBadgeProps = Pick<BadgeProps, 'className' | 'testId'>;

export const BetaBadge = ({ className, testId }: BetaBadgeProps) => {
  return (
    <Badge
      color="info"
      iconName="flask"
      size="small"
      className={className}
      testId={testId}
    >
      Beta
    </Badge>
  );
};
